import { motion } from "framer-motion";

const ROKET_IMAGE = "https://customer-assets.emergentagent.com/job_6e94cf61-ed07-442f-8a8f-1e142db37be8/artifacts/bvtijyq3_IMG_6616.jpg";

const RoketAvatar = ({ size = 40, animate = true }) => {
  return (
    <motion.div
      className="relative rounded-full overflow-hidden bg-slate-100"
      style={{ width: size, height: size }}
      animate={animate ? { scale: [1, 1.02, 1] } : {}}
      transition={{ duration: 2, repeat: Infinity, ease: "easeInOut" }}
    >
      <img 
        src={ROKET_IMAGE} 
        alt="Roket" 
        className="w-full h-full object-cover"
        style={{ objectPosition: 'center 20%' }}
      />
    </motion.div>
  );
};

export default RoketAvatar;
